import useRouteMatch from '~/hooks/useRouteMatch';
import { RouteConfig } from '~/routes/routeConfig';
import { OutstandingDataDirection } from '~/types/outstanding';

export const useOustandingRouteType = () => {
  const inflowPath = RouteConfig.OutstandingFlowsInflow.buildLink();
  const outflowPath = RouteConfig.OutstandingFlowsOutflow.buildLink();
  const allPath = RouteConfig.OutstandingFlowsAll.buildLink();
  const match = useRouteMatch([inflowPath, outflowPath, allPath]);

  if (match === inflowPath) return OutstandingDataDirection.Inflow;
  if (match === outflowPath) return OutstandingDataDirection.Outflow;
  return undefined;
};
